module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 73300.e75473f3.png";